import { url } from "aldoo-ra/CMS/url"

/**
 * Avatar Update Helper
 *
 * Provides a centralized way to update user avatars across the page
 * when a user's avatar changes.
 */

/**
 * Updates all avatar images for a specific user on the current page
 *
 * @param {string} userId - The user's ID
 * @param {string} newAvatarUrl - The new avatar URL (can be relative or absolute)
 */
export function updateUserAvatarOnPage(userId, newAvatarUrl) {
  if (!userId || !newAvatarUrl) return

  // Resolve the URL in case it's relative
  const resolvedUrl = url(newAvatarUrl)

  // Find all img elements with data-user-avatar attribute matching this user
  const avatarElements = document.querySelectorAll(`img[data-user-avatar="${userId}"]`)

  avatarElements.forEach(img => {
    img.src = resolvedUrl
  })

  console.log(`Updated ${avatarElements.length} avatar images for user ${userId}`)
}

/**
 * Get avatar data attribute for an image element
 *
 * Usage: <img src={...} {...avatarDataAttr(user)} />
 *
 * @param {string|object} user - The user's ID or user object
 * @returns {object} Props to spread on the img element
 */
export function avatarDataAttr(user) {
  if (!user) return {}

  const userId = typeof user === 'string' ? user : (user._id || user.id)
  if (!userId) return {}

  return {
    'data-user-avatar': userId
  }
}

// Also export as getAvatarDataProps for backwards compatibility
export const getAvatarDataProps = avatarDataAttr
